import './Nav.scss'
import React from 'react';

export default function NavGreen (props) {
    return (
        <div className="container-nav-green">
            <span className="container-info">
                <h3>{ props.title }</h3>
            </span>
        </div>
    )
}